import { useIsMobile } from '@stores/AppCommonData';
import InProgressStatus from './InProgressStatus';
import SubjectiveActions from './SubjectiveActions';
import DefaultActions from './DefaultActions';
import useQuizStatus from '../../Common/useQuizStatus';

const Actions = () => {
  const {
    isLive,
    isSubjectiveAnswerUploadPending,
    isEvaluationPending,
    hasAttempted
  } = useQuizStatus();
  const isMobile = useIsMobile();
  if (isSubjectiveAnswerUploadPending || isEvaluationPending) {
    return <SubjectiveActions />;
  }

  if (isLive && hasAttempted && !isMobile) {
    return (
      <InProgressStatus
        title="Test is in progress"
        description="Your attempt has been submitted"
      />
    );
  }

  return <DefaultActions />;
};

export default Actions;
